import { styled } from "styled-components";

import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Spacer = styled.div<{ desktop: string; mobile: string }>(
    ({ desktop, mobile }) => `
    ${redundantCssFromKebab("height", `${mobile}`)}
    @media (min-width: 768px) {
      ${redundantCssFromKebab("height", `${desktop}`)}
    }
  `
);
